module.exports = __webpack_public_path__ + "media/site/images/products/eplaning-screen2-636d4230ea5ed0002d93461789b9427f.png";